import { IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';
import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';
import {
  OTHER_INCOME_STRUCTURE_ID,
  INCOME_SUBGROUP_CATEGORY,
  TOTAL_INCOME_STRUCTURE_ID,
} from 'src/Enum/IncomeStructure';
import { calcNetIncomeItem, sumExtendedValues, yearFields } from '../../utils';

type ProductIncomeDeleteButtonProps = {
  keyItem: string;
};

const ProductIncomeDeleteButton = ({
  keyItem,
}: ProductIncomeDeleteButtonProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, unregister, watch, setValue } = useNatureOfBusinessForm();

  const completedSection = watch(
    'incomeStructure.completedSection'
  ) as IIncomeStructureFormValues['completedSection'];
  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  const productIncomeItems = getValues(
    'incomeStructure.productIncomeItems'
  ) as IIncomeStructureFormValues['productIncomeItems'];
  const topicTh = productIncomeItems[keyItem].incomeCategory?.nameTh ?? '';

  const handleDelete = () => {
    unregister(`incomeStructure.productIncomeItems.${keyItem}`);
    unregister(`incomeStructure.productIncomePercentages.${keyItem}`);

    yearFields.map((yearField) => {
      const totalValue = productIncomeItems[
        TOTAL_INCOME_STRUCTURE_ID.TOTAL_PRODUCT_INCOME
      ][yearField] as string;
      const extendedValues = sumExtendedValues(
        productIncomeItems,
        INCOME_SUBGROUP_CATEGORY.PRODUCT_INCOME,
        yearField
      );

      if (totalValue !== '' && extendedValues !== '') {
        setValue(
          `incomeStructure.productIncomeItems.${OTHER_INCOME_STRUCTURE_ID.OTHER_PRODUCT_INCOME}.${yearField}`,
          calcNetIncomeItem(totalValue, extendedValues)
        );
      } else {
        setValue(
          `incomeStructure.productIncomeItems.${OTHER_INCOME_STRUCTURE_ID.OTHER_PRODUCT_INCOME}.${yearField}`,
          ''
        );
      }
    });

    close();
  };

  return (
    <>
      <IconButton
        color="inherit"
        size="small"
        sx={{ padding: 0 }}
        onClick={open}
        disabled={isCompletedTh || isCompletedEn}
      >
        <DeleteOutlineIcon style={{ fontSize: '14px' }} />
      </IconButton>
      <DeleteModal
        topic={topicTh}
        opened={opened}
        close={close}
        confirm={handleDelete}
      />
    </>
  );
};

export default ProductIncomeDeleteButton;
